// extracted by mini-css-extract-plugin
export var bgGradientPpc = "index-module--bg-gradient-ppc--e5cf3";
export var bulletsHeroPpc = "index-module--bullets-hero-ppc--4df8c";
export var heading = "index-module--heading--d18e9";
export var headingContainer = "index-module--heading-container--28d20";
export var highlight = "index-module--highlight--46022";
export var highlightLine = "index-module--highlight-line--7db51";
export var image1 = "index-module--image-1--1c61d";
export var image2 = "index-module--image-2--40350";
export var imageContainer = "index-module--image-container--06624";